import React from 'react'
import moment from 'moment'
import {
    Row,
    Column,
    HeaderRow,
    HeaderText,
    HeaderTextfield,
} from './PrintFormComponents'

import BraunLogoColored from '../../img/BraunLogoColored.png'

export default ({ responsible, title}) => {
    const dateToday = moment().format('DD.MM.YYYY')

    return(
        <Row style={{ marginBottom: '70px' }}>
            <Column><img src={BraunLogoColored} alt="B.Braun Logo" style={{ width: '250px', marginLeft: '25px', marginTop: '40px' }}/></Column>
            <Column>
                <p style={{ fontSize: '15pt', fontWeight: '600', marginBottom: '7px' }}>Abteilung</p>
                <HeaderRow><HeaderText>von: </HeaderText><HeaderTextfield rows="1" defaultValue={responsible}/></HeaderRow>
                <HeaderRow><HeaderText>Datum: </HeaderText><HeaderTextfield rows="1" defaultValue={dateToday}/></HeaderRow>
                <p style={{ fontSize: '18pt', fontWeight: '600', marginTop: '40px' }}>{title}</p>
            </Column>
        </Row>
    )
}



// WEBPACK FOOTER //
// ./src/components/printForm/PrintFormHeader.js